import { useEffect, useMemo } from "react";
import { Navigate, useParams } from "react-router-dom";
import { useNavState } from "@/navigation/useNavState";
import { getAsset } from "@/data/catalogue";
import { affineFor } from "@/data/search";
import { applyRouteMode } from "@/styles/theme";
import { useFlyingImage } from "@/transitions/FlyingImage";
import ExploreTab from "@/components/detail/ExploreTab";
import ViewerTab from "@/components/detail/ViewerTab";
import PrototypingTab from "@/components/detail/PrototypingTab";
import QualityTab from "@/components/detail/QualityTab";
import RevisionTab from "@/components/detail/RevisionTab";
import type { TabId } from "@/components/TopPanel";
import "./Detail.css";

export default function Detail({
  tab,
  exiting,
  onExit,
}: {
  tab: TabId;
  exiting?: boolean;
  onExit?: (to: string) => void;
}) {
  const { ref } = useParams<{ ref: string }>();
  const state = useNavState();

  const asset = getAsset(ref);
  const affine = useMemo(() => (asset ? affineFor(asset.ref) : []), [asset]);

  const { clear } = useFlyingImage();

  useEffect(() => {
    applyRouteMode("light");
    document.body.dataset.scroll = "lock";
    const t = setTimeout(clear, 300);
    return () => {
      clearTimeout(t);
      delete document.body.dataset.scroll;
    };
  }, []);

  if (!asset) return <Navigate to="/" replace />;

  return (
    <div className="detail-body">
      {tab === "esplora" && (
        <ExploreTab
          key={asset.ref}
          asset={asset}
          affine={affine}
          state={state}
          exiting={exiting}
          onExit={onExit}
        />
      )}
      {tab === "viewer" && <ViewerTab asset={asset} />}
      {tab === "prototipia" && <PrototypingTab asset={asset} />}
      {tab === "qualita" && <QualityTab asset={asset} state={state} />}
      {tab === "revisione" && <RevisionTab asset={asset} state={state} />}
    </div>
  );
}
